import { ajax, uploadImg } from "./request.js";
import vue from "vue";

vue.config.productionTip = false;

function getRequestLang(type) {
  if (type === "zh-cn") return "zh-cn";
  else if (type === "en") return "en-us";
  else return "zh-cn";
}

// var baseUrl =
//   process.env.NODE_ENV === "development" ? "" : "http://43.135.4.137:8088"; // 测试服

var baseUrl =
  process.env.NODE_ENV === "development"
    ? ""
    : "https://apiv2.faceline.live:443"; // 正式服

function getRequestUrl(url, aa) {
  let query = "";
  if (aa) {
    query = `&noOther=${aa.noOther}&area=${aa.area}`;
  }
  return (
    baseUrl +
    url +
    `?lang=${getRequestLang(
      vue.prototype.$selfGlobal.$globalStore.state.locale
    )}` +
    query
  );
}

// 登录
function login(data, config) {
  return ajax("post", getRequestUrl("/v1/manager/login"), data, config);
}

// 退出登录
function loginOut() {
  return ajax("post", getRequestUrl("/api/Login/logout"), {});
}

// 操作密码
function checkAdminPwd(data) {
  return ajax("post", getRequestUrl("/api/Admin/checkAdminPwd"), data);
}

// 导出表格
function exportData(arr) {
  let url = baseUrl + "/api/Service/servicekProblemListExport?" + arr.join("&");
  window.open(url, "_blank");
}

// 上传图片
function upload(data) {
  return uploadImg(getRequestUrl("/v1/mgr/gift/image"), data);
}

// 视频聊天 (数据统计)
function videoChatStatistics(data, method) {
  return ajax("post", getRequestUrl("/v1/video/data"), data, {
    method
  });
}

// 管理员 -- 列表
function getAdminList(data, method) {
  return ajax("get", getRequestUrl("/admin/administrator/index"), data, {
    method
  });
}

// 管理员 -- 添加
function createAdmin(data, method) {
  return ajax("post", getRequestUrl("/admin/administrator/create"), data, {
    method
  });
}

// 管理员 -- 删除
function deleteAdmin(data, method) {
  return ajax("post", getRequestUrl("/admin/administrator/delete"), data, {
    method
  });
}

// 管理员 -- 更新
function updateAdmin(data, method) {
  return ajax("post", getRequestUrl("/admin/administrator/update"), data, {
    method
  });
}

// 管理员 -- 查看他的权限
function getPermission(data, method) {
  return ajax("get", getRequestUrl("/v1/manager/permission"), data, {
    method
  });
}

// 管理员 -- 修改他的权限
function editPermission(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/permission"), data, {
    method
  });
}

// 管理员 -- 设置代理销售明细可查询国家
function settCountryList(data, method) {
  return ajax("get", getRequestUrl("/v2/country/list"), data, {
    method
  });
}
// 管理员 -- 设置代理销售明细可查询国家(确定)
function setSave(data, method) {
  return ajax("post", getRequestUrl("/v2/country/mgrUser/set"), data, {
    method
  });
}
// 管理员 -- 设为资料管理人
function setDataSave(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/info/manager"), data, {
    method
  });
}
// 管理员 -- 删除资料管理人
function delDataSave(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/info/manager/${data.code}`),
    data,
    {
      method
    }
  );
}
// 礼品 -- 礼物列表
function giftIndex(data, method) {
  return ajax("get", getRequestUrl("/v1/gift/page"), data, {
    method
  });
}

// 礼品 -- 礼物修改
function giftUpdate(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/gift/edit"), data, {
    method
  });
}

// 礼品 -- 礼物创建
function giftCreate(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/gift/add"), data, {
    method
  });
}

// 礼品 -- 礼物下架
function giftSwitch(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/gift/switch"), data, {
    method
  });
}

// 礼品 -- 礼物详情
function giftDetail(data, method) {
  return ajax("get", getRequestUrl("/admin/gift/detail"), data, {
    method
  });
}

// 客服 -- 反馈信息列表
function reportFeedbacks(data, method) {
  return ajax("get", getRequestUrl("/v1/customer/feedback"), data, {
    method
  });
}

// 客服 -- 举报列表
function reportList(data, method) {
  return ajax("get", getRequestUrl("/v1/customer/report"), data, {
    method
  });
}

// 客服 -- 封禁用户
function reportBanUser(data, method) {
  return ajax("post", getRequestUrl("/admin/user/ban"), data, {
    method
  });
}

// 客服 -- 处理投诉
function reportHandle(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/report"), data, {
    method
  });
}

// 用户 -- 用户信息列表
function usersList(data, method) {
  return ajax("get", getRequestUrl("/v1/user/page"), data, {
    method
  });
}

// 修改用户性别
function updateSex(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/user/sex"), data, {
    method
  });
}

// 用户 -- 用户设置工会
function userUnionUpdate(data, method) {
  return ajax(
    "post",
    getRequestUrl(`/v1/mgr/user/tradeUnion/${method.code}`),
    data,
    {
      method
    }
  );
}

// 用户 -- 用户/工会用户连接日志
function usersConnects(data, method) {
  return ajax("get", getRequestUrl("/v1/user/video"), data, {
    method
  });
}

// 用户 -- 用户明细
function chargePayments(data, method) {
  return ajax("get", getRequestUrl("/v1/user/charge"), data, {
    method
  });
}

// 用户 -- 用户（充值记录）更新为（充值统计）
function usersPayments(data, method) {
  return ajax(
    "get",
    getRequestUrl(`/v1/user/charge/summary/${data.code}/${data.period}`),
    data,
    {
      method
    }
  );
}

// 用户 -- 消费记录
function usersConsume(data, method) {
  return ajax("get", getRequestUrl("/v1/user/consume"), data, {
    method
  });
}

// 用户 -- 用户赠送宝石
function usersPaymentsCreate(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/diamond/send"), data, {
    method
  });
}

// 用户 -- 用户赠送游戏币
function usersSendGameMonty(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/diamondPink/send"), data, {
    method
  });
}

// 用户 -- 消费统计
function statsConsume(data, method) {
  return ajax("get", getRequestUrl("/v1/stats/consume"), data, {
    method
  });
}

// 用户 -- 扣除钻石
function diamondReduce(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/diamond/reduce"), data, {
    method
  });
}

// 用户 -- 扣除金币
function goldReduce(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/gold/reduce"), data, {
    method
  });
}

// 用户 -- 增加vip天数
function usersVipCreate(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/vip/day"), data, {
    method
  });
}
// 用户 -- 删除vip
function deleteVip(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/vip/${method.code}`),
    data,
    {
      method
    }
  );
}

// 用户 -- 用户详情 -- 筛选接口
function userSearch(data, method) {
  return ajax("get", getRequestUrl("/v1/user/detail"), data, {
    method
  });
}

// 用户 -- 用户处理 -- 用户处理（冻结，解冻）
function userDeal(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/deal"), data, {
    method
  });
}

// 用户 -- 用户处理 -- 用户处理（封禁广播）
function userBroadcast(data, method) {
  return ajax(
    "post",
    getRequestUrl("/v1/mgr/user/global/broadcast/limit"),
    data,
    {
      method
    }
  );
}

// 用户 -- 用户处理 -- 用户处理（解除封禁广播）
function relieveUserBroadcast(data, method) {
  return ajax(
    "post",
    getRequestUrl("/v1/mgr/user/global/broadcast/allow"),
    data,
    {
      method
    }
  );
}

// 用户（赠送贵族）
function sendNobility(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/noble/user"), data, {
    method
  });
}

// 用户（赠送道具）
function sendProps(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/bag/send"), data, {
    method
  });
}

// 用户（退出家族）
function userLeave(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/groupPower/user/leave"), data, {
    method
  });
}

// 用户（设为超管）
function addManager(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/super/manager"), data, {
    method
  });
}

// 用户（取消超管）
function delManager(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/super/manager/${method.code}`),
    data,
    {
      method
    }
  );
}

// 用户（设为全球广播管理人）
function addBroadcastAdministrator(data, method) {
  return ajax(
    "post",
    getRequestUrl("/v1/mgr/user/global/broadcast/manager"),
    data,
    {
      method
    }
  );
}

// 用户（取消全球广播管理人）
function delBroadcastAdministrator(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/global/broadcast/manager/${method.code}`),
    data,
    {
      method
    }
  );
}

// 用户 -- 移除公会用户
function userTradeUnionDel(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/tradeUnion/${method.code}`),
    data,
    {
      method
    }
  );
}

// 用户 -- 封禁设备
function banDevice(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/imei"), data, {
    method
  });
}

// 用户 -- 解除封禁设备
function unBanDevice(data, method) {
  return ajax("delete", getRequestUrl(`/v1/mgr/imei/${method.imei}`), data, {
    method
  });
}

// 用户 -- 国家列表
function getCountryList(data, method) {
  return ajax("get", getRequestUrl("/v1/user/country"), data, {
    method
  });
}

// 用户 -- 国家列表(分区)
function getCountryArea(data, method) {
  return ajax("get", getRequestUrl(`/v1/user/country/${method.area}`), data, {
    method
  });
}

//
// 用户 -- 国家列表v2
function getCountryListTwo(data, method) {
  return ajax("get", getRequestUrl("/v2/country/mgrUser/list"), data, {
    method
  });
}

// 用户 -- 加入推荐
function userRecommend(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/recommend"), data, {
    method
  });
}

// 用户 -- 删除用户
function manageDel(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/logic/${method.code}`),
    data,
    {
      method
    }
  );
}

// 用户 -- 重置用户头像
function resetAvatar(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/avatar/${method.code}`),
    data,
    {
      method
    }
  );
}

// 用户 -- 相册
function getUserPhoto(data, method) {
  return ajax("get", getRequestUrl("/v1/user/photo"), data, {
    method
  });
}

// 用户 -- 删除相册图片
function photoDelete(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/photo/${method.id}`),
    data,
    {
      method
    }
  );
}

// 用户 -- 添加运营备忘
function userMemo(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/memo"), data, {
    method
  });
}

// 用户 -- 修改昵称
function updateUserNick(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/user/nick"), data, {
    method
  });
}

// 用户 -- 修改等级（财富、魅力、活跃）
function updateUserLevel(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/user/grade"), data, {
    method
  });
}

// 用户 -- 修改成靓号
function updateUserCode(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/user/code"), data, {
    method
  });
}

// 用户 -- 删除用户靓号
function resetUserCode(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/user/code/reset"), data, {
    method
  });
}

// 用户 -- 查看道具
function checkProp(data, method) {
  return ajax("get", getRequestUrl(`/v1/user/property/${data.code}`), data, {
    method
  });
}

// 用户 -- 删除道具
function deleteProp(data, method) {
  return ajax(
    "put",
    getRequestUrl(`/v1/mgr/user/property/${data.code}`),
    data,
    {
      method
    }
  );
}

// 用户 -- 钻石收入记录
function diamondIncomeList(data, method) {
  return ajax("get", getRequestUrl("/v1/user/diamondIncome"), data, { method });
}

// 设为主播 / 加入公会
function addTradeUnion(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/tradeUnion"), data, {
    method
  });
}

// 取消主播 / 加入公会
function deleteTradeUnion(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/tradeUnion/${data.code}`),
    data,
    {
      method
    }
  );
}

// 用户-设为国家管理员/助理
function countryAdministration(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/country/manager"), data, {
    method
  });
}

// 用户-删除国家管理员/助理
function deleteAdministration(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/user/country/manager/${data.code}`),
    data,
    {
      method
    }
  );
}

// 用户-创建账号
function createCode(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/create"), data, {
    method
  });
}

// 用户--封禁IP
function banInterface(data, method) {
  return ajax("post", getRequestUrl("/v1/user/ip/ban"), data, {
    method
  });
}
// 用户--解除封禁IP
function banRescind(data, method) {
  return ajax("post", getRequestUrl("/v1/user/ip/ban/del"), data, {
    method
  });
}

// 公会 -- 公会列表
function unionUserList(data, method) {
  return ajax("get", getRequestUrl("/v1/guildUser/page"), data, {
    method
  });
}

// 公会 -- 上传封面
function associationAvatar(data, method) {
  return ajax("put", getRequestUrl("/v1/guildUser/avatar"), data, {
    method
  });
}

// 公会 -- 匹配记录
function unionConnectList(data, method) {
  return ajax("get", getRequestUrl("/v1/guildUser/video"), data, {
    method
  });
}

// 公会 -- 公会用户详情
function unionConnectDetail(data, method) {
  return ajax("get", getRequestUrl("/v1/guildUser/detail"), data, {
    method
  });
}

// 公会 -- 指标统计
function unionConnectStats(data, method) {
  return ajax("get", getRequestUrl("/v1/guildUser/stats"), data, {
    method
  });
}

// 代理 -- 公会 -- 更新公会代理
function updateAgentUnion(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/tradeUnionAgent"), data, {
    method
  });
}

// 代理 -- 更新工会代理名字
function updateAgentName(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/tradeUnion/agent"), data, {
    method
  });
}

// 代理 -- 公会列表 分页
function agentListPage(data, method) {
  return ajax("get", getRequestUrl("/v1/tradeUnion/agent/page"), data, {
    method
  });
}

// 代理 -- 添加
function addAgentPage(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/tradeUnion/agent"), data, {
    method
  });
}

// 代理 -- 编辑
function editAgentPage(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/tradeUnion/agent"), data, {
    method
  });
}

// 代理 -- 删除
function deleteAgentPage(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/tradeUnion/agent/${method.id}`),
    data,
    {
      method
    }
  );
}

// 代理 -- 设置代理管理员
function editAgentMgr(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/tradeUnion/agentMgr"), data, {
    method
  });
}

// 代理 -- 删除代理管理员
function deleteAgentMgr(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/tradeUnion/deleteAgentMgr/${method.agentId}`),
    data,
    {
      method
    }
  );
}

// 代理 -- 设置starchatId
function setStarchatId(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/tradeUnion/starchatId"), data, {
    method
  });
}

// 匹配日志
function matchCyclePage(data, method) {
  return ajax("get", getRequestUrl("/v1/match/cycle/page"), data, {
    method
  });
}

// 匹配周期结果详情
function matchCyclePageDetail(data, method) {
  return ajax("get", getRequestUrl("/v1/match/cycle/detail/page"), data, {
    method
  });
}

// 匹配周期详情页下的优先度
function matchLogSTotalDetail(data, method) {
  return ajax("get", getRequestUrl("/v1/match/cycle/priority"), data, {
    method
  });
}

// 匹配周期关系总分
function matchLogSRelation(data, method) {
  return ajax("get", getRequestUrl("/v1/match/cycle/relation"), data, {
    method
  });
}

// 匹配周期详情页下的质量
function matchLogExcellent(data, method) {
  return ajax("get", getRequestUrl("/v1/match/cycle/excellent"), data, {
    method
  });
}

// 1.1.4 匹配总分详情页 -- 前三个分值关系分值高的用户
function matchLogRelationTop(data, method) {
  return ajax("get", getRequestUrl("/v1/match/cycle/relation/top"), data, {
    method
  });
}

// 落单用户
function matchLogSingle(data, method) {
  return ajax("get", getRequestUrl("/v1/match/cycle/single"), data, {
    method
  });
}

// 匹配 -- 用户匹配推送记录
function matchRpc(data, method) {
  return ajax("get", getRequestUrl("/v1/match/cycle/rpc"), data, {
    method
  });
}

// 平台运营数据 -- 日统计列表
function dailyStatistics(data, method) {
  return ajax("get", getRequestUrl(`/v1/stats/day/${method.area}`), data, {
    method
  });
}

// 平台运营数据 -- 月统计
function monthStatistics(data, method) {
  return ajax("get", getRequestUrl(`/v1/stats/month/${method.area}`), data, {
    method
  });
}

// 平台运营数据 -- 总统计
function totalStatistics(data, method) {
  return ajax("get", getRequestUrl(`/v1/stats/total/${method.area}`), data, {
    method
  });
}
// 平台运营数据 -- VIP充值明细
function viplStatistics(data, method) {
  return ajax("get", getRequestUrl(`/v1/stats/vip/${method.area}`), data, {
    method
  });
}

// 平台运营数据 -- 周统计
function weekStatistics(data, method) {
  return ajax("get", getRequestUrl(`/v1/stats/week/${method.area}`), data, {
    method
  });
}

// 平台运营数据 -- 充值明细
function rechargeStatistics(data, method) {
  return ajax(
    "get",
    getRequestUrl(`/v1/stats/charge/detail/${method.area}`),
    data,
    {
      method
    }
  );
}

// 平台运营数据 -- 消费统计
function consumeStatistics(data, method) {
  return ajax("get", getRequestUrl(`/v1/stats/consume/${method.area}`), data, {
    method
  });
}

// 推荐用户管理 -- 列表
function recommendPage(data, method) {
  return ajax("get", getRequestUrl("/v1/recommend/page"), data, {
    method
  });
}

// 推荐用户管理 -- 移除推荐用户列表
function recommendDel(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/recommend/${method.code}`),
    data,
    {
      method
    }
  );
}

// 管理人 -- 查询管理人
function managerPage(data, method) {
  return ajax("get", getRequestUrl(`/v1/manager/page`), data, {
    method
  });
}

// 管理人 -- 编辑管理人
function managerEdit(data, method) {
  return ajax("put", getRequestUrl(`/v1/mgr/manager`), data, {
    method
  });
}

// 管理人 -- 增加管理人
function managerAdd(data, method) {
  return ajax("post", getRequestUrl(`/v1/mgr/manager`), data, {
    method
  });
}

// 管理人 -- 禁用管理人
function managerNoUser(data, method) {
  return ajax("put", getRequestUrl(`/v1/mgr/no/user`), data, {
    method
  });
}

// 公会用户 -- 所有的公会用户
function agentAll(data, method) {
  return ajax("get", getRequestUrl(`/v1/tradeUnion/agent/all`), data, {
    method
  });
}

// 广告 -- 查询广告
function advertiseList(data, method) {
  return ajax("get", getRequestUrl(`/v1/advertise/`), data, {
    method
  });
}

// 广告 -- 修改广告
function advertiseEdit(data, method) {
  return ajax("put", getRequestUrl(`/v1/mgr/advertise`), data, {
    method
  });
}

// 广告 -- 增加广告
function advertiseAdd(data, method) {
  return ajax("post", getRequestUrl(`/v1/mgr/advertise`), data, {
    method
  });
}

// 广告 -- 广告上下架
function advertiseSwitch(data, method) {
  return ajax("put", getRequestUrl(`/v1/mgr/advertise/switch`), data, {
    method
  });
}

// 活动 -- 活动列表 获取所有活动配置
function activityList(data, method) {
  return ajax("get", getRequestUrl(`/v1/activity/config`), data, {
    method
  });
}

// 活动 -- 修改活动 修改活动配置
function activityEdit(data, method) {
  return ajax("put", getRequestUrl(`/v1/mgr/activity/config`), data, {
    method
  });
}

// 活动 -- 添加活动 增加活动配置
function activityAdd(data, method) {
  return ajax("post", getRequestUrl(`/v1/mgr/activity/config`), data, {
    method
  });
}

//  道具 -- 修改道具
function propertyEdit(data, method) {
  return ajax("put", getRequestUrl(`/v1/mgr/property`), data, {
    method
  });
}

//  道具 -- 添加道具
function propertyAdd(data, method) {
  return ajax("post", getRequestUrl(`/v1/mgr/property`), data, {
    method
  });
}

//  道具 -- 添加道具给用户
function propertyAddToUser(data, method) {
  return ajax("post", getRequestUrl(`/v1/mgr/property/add`), data, {
    method
  });
}

//  道具 -- 删除用户道具
function propertyRemoveToUser(data, method) {
  return ajax("put", getRequestUrl(`/v1/mgr/property/remove`), data, {
    method
  });
}

//  道具 -- 道具列表 获取所有道具配置
function propertyList(data, method) {
  return ajax("get", getRequestUrl(`/v1/property/`), data, {
    method
  });
}

//  道具 -- 道具列表 获取所有该用户的道具配置
function propertyUserList(data, method) {
  return ajax("get", getRequestUrl(`/v1/property/${method.id}`), data, {
    method
  });
}

//  群组 -- 查询群组
function groupList(data, method) {
  return ajax("get", getRequestUrl("/v1/group/"), data, {
    method
  });
}

//  群组 -- 查询群组-banner
function getgroupBanner(data, method) {
  return ajax("get", getRequestUrl("/v1/group/banner/page"), data, {
    method
  });
}

//  群组 -- 解封群组
function groupAllow(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/allow"), data, {
    method
  });
}

//  群组 -- 封禁群组
function groupBan(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/ban"), data, {
    method
  });
}

//  群组 -- 置顶
function groupOnTop(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/onTop"), data, {
    method
  });
}

//  群组 -- 取消置顶
function groupOnTopCancel(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/group/onTop/${method.code}`),
    data,
    {
      method
    }
  );
}

//  群组 -- 修改资料
function groupProfile(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/profile"), data, {
    method
  });
}

// 群组 -- 设置靓号
function groupBeautifulCodePut(data, method) {
  return ajax(
    "put",
    getRequestUrl(`/v1/mgr/group/beautifulCode/${method.code}`),
    data,
    {
      method
    }
  );
}

// 群组 -- 移除靓号
function groupBeautifulCodeDelete(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/group/beautifulCode/${method.code}`),
    data,
    {
      method
    }
  );
}

// 群组 -- （在群热门中）隐藏/取消隐藏
function putGrouphide(data, method) {
  return ajax("put", getRequestUrl(`/v1/mgr/group/hide/${method.code}`), data, {
    method
  });
}

// 房间管理--房间活动管理--列表
function getRoomList(data, method) {
  return ajax("get", getRequestUrl("/v1/agentChargeAct/list"), data, {
    method
  });
}
//  房间管理 -- 房间活动管理 -- 添加活动
function getAddCreateAct(data, method) {
  return ajax("post", getRequestUrl("/v1/agentChargeAct/create"), data, {
    method
  });
}
//  房间管理 -- 房间活动管理 -- 编辑活动
function getUpdateAct(data, method) {
  return ajax("put", getRequestUrl("/v1/agentChargeAct/update"), data, {
    method
  });
}
// 房间管理 -- 活动上下架
function actSwitch(data, method) {
  return ajax("put", getRequestUrl("/v1/agentChargeAct/status"), data, {
    method
  });
}
// 房间管理--房间审批--列表
function getExamineList(data, method) {
  return ajax("get", getRequestUrl("/v1/agentChargeAct/audit/list"), data, {
    method
  });
}

//  房间管理 -- 特权操作记录 -- 列表
function getPrivilegeList(data, method) {
  return ajax("get", getRequestUrl("/v1/agentChargeAct/audit/list"), data, {
    method
  });
}

//  房间管理 -- 特殊房间充值活动 -- 活动列表
function getRoomSpecList(data, method) {
  return ajax("get", getRequestUrl("/v1/agentChargeSpecAct/list"), data, {
    method
  });
}
//  房间管理 -- 特殊房间充值活动 -- 添加活动
function getAddSpecAct(data, method) {
  return ajax("post", getRequestUrl("/v1/agentChargeSpecAct/create"), data, {
    method
  });
}
//  房间管理 -- 特殊房间充值活动 -- 编辑活动
function getUpdateSpecAct(data, method) {
  return ajax("put", getRequestUrl("/v1/agentChargeSpecAct/update"), data, {
    method
  });
}
//  房间管理 -- 特殊房间充值活动 -- 复制活动
function getCopySpecAct(data, method) {
  return ajax("post", getRequestUrl("/v1/agentChargeSpecAct/copy"), data, {
    method
  });
}
// 房间管理 --特殊房间充值活动 -- 活动上下架
function actSpecSwitch(data, method) {
  return ajax("put", getRequestUrl("/v1/agentChargeSpecAct/status"), data, {
    method
  });
}
//  房间管理 -- 特殊房间充值活动 -- 房间审批
function getExamineSpeList(data, method) {
  return ajax("get", getRequestUrl("/v1/agentChargeSpecAct/audit/list"), data, {
    method
  });
}

//  房间管理 -- 特殊房间充值活动 -- 查询任务1
function getTaskSpecAct(data, method) {
  return ajax("get", getRequestUrl("/v1/agentChargeSpecAct/task/list"), data, {
    method
  });
}
//  房间管理 -- 特殊房间充值活动 -- 添加任务1
function getAddTaskSpecAct(data, method) {
  return ajax(
    "post",
    getRequestUrl("/v1/agentChargeSpecAct/task/create"),
    data,
    {
      method
    }
  );
}
//  房间管理 -- 特殊房间充值活动 -- 编辑任务1
function getEditTaskSpecAct(data, method) {
  return ajax(
    "put",
    getRequestUrl("/v1/agentChargeSpecAct/task/update"),
    data,
    {
      method
    }
  );
}
//  房间管理 -- 特殊房间充值活动 -- 删除任务1
function delTaskSpecAct(data, method) {
  return ajax(
    "delete",
    getRequestUrl(
      `/v1/agentChargeSpecAct/task/${data.configId}/${data.taskId}`
    ),
    data,
    {
      method
    }
  );
}
//  房间管理 -- 特殊房间充值活动 -- 复制任务1
function getCopyTaskSpecAct(data, method) {
  return ajax("post", getRequestUrl("/v1/agentChargeSpecAct/task/copy"), data, {
    method
  });
}

//  房间管理 -- 特殊房间充值活动 -- 任务 -- 查询奖励1
function getAwardSpecAct(data, method) {
  return ajax("get", getRequestUrl("/v1/agentChargeSpecAct/award/list"), data, {
    method
  });
}
//  房间管理 -- 特殊房间充值活动  -- 任务 -- 添加奖励1
function getAddAwardSpecAct(data, method) {
  return ajax(
    "post",
    getRequestUrl("/v1/agentChargeSpecAct/award/create"),
    data,
    {
      method
    }
  );
}
//  房间管理 -- 特殊房间充值活动 -- 任务  -- 编辑奖励1
function getEditAwardSpecAct(data, method) {
  return ajax(
    "put",
    getRequestUrl("/v1/agentChargeSpecAct/award/update"),
    data,
    {
      method
    }
  );
}
//  房间管理 -- 特殊房间充值活动    -- 任务  -- 删除奖励1
function delAwardSpecAct(data, method) {
  return ajax(
    "delete",
    getRequestUrl(
      `/v1/agentChargeSpecAct/award/${data.configId}/${data.taskId}/${data.awardId}`
    ),
    data,
    {
      method
    }
  );
}

// 系统消息 -- 系统消息列表
function getBannerPage(data, method) {
  return ajax("get", getRequestUrl("/v1/msg/sys/page"), data, {
    method
  });
}

// 系统消息 -- 增加系统消息
function addBannerPage(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/msg/sys"), data, {
    method
  });
}

// 系统消息 -- 更新系统消息
function editBannerPage(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/msg/sys"), data, {
    method
  });
}

// 系统消息 -- 删除系统消息
function deleteBannerPage(data, method) {
  return ajax("delete", getRequestUrl(`/v1/mgr/msg/sys/${method.id}`), data, {
    method
  });
}

// 群发消息 -- 群发消息列表
function getMassTextingPage(data, method) {
  return ajax("get", getRequestUrl("/v1/msg/batch/page"), data, {
    method
  });
}

// 群发消息--群发IM消息
// function massTextingIM(data, method) {
//   return ajax("post", getRequestUrl("/v1/mgr/msg/batch"), data, {
//     method
//   });
// }
function massTextingIM(data, method) {
  return uploadImg(getRequestUrl("/v1/mgr/msg/batch"), data);
}

// banner管理 -- banner列表
function bannerManagementList(data, method) {
  return ajax("get", getRequestUrl("/v1/group/banner/page"), data, {
    method
  });
}

// banner管理 -- 编辑banner
function bannerManagementEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/banner"), data, {
    method
  });
}

// banner管理 -- 添加banner
function bannerManagementAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/group/banner"), data, {
    method
  });
}

// banner管理 -- banner下架
function bannerManagementNouser(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/banner/nouser"), data, {
    method
  });
}

// banner管理 -- banner上架
function bannerManagementUse(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/group/banner/user"), data, {
    method
  });
}
// 群组banner列表

function getBannerRoom(data, method) {
  return ajax("get", getRequestUrl("/v1/group/banner/room"), data, {
    method
  });
}
// 更新房间banner
function putBannerRoom(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/room/banner"), data, {
    method
  });
}
//上下架房间banner
function putBannerRoomStatus(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/room/banner/status"), data, {
    method
  });
}
// 新增房间banner
function postBannerRoom(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/room/banner"), data, {
    method
  });
}

// 代理banner -- banner列表
function bannerAgentList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/agent/banners"), data, {
    method
  });
}

// 代理banner -- 编辑banner
function bannerAgentEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/agent/banner"), data, {
    method
  });
}

// 代理banner -- 添加banner
function bannerAgentAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/agent/banner"), data, {
    method
  });
}

// 代理banner -- banner下架
function bannerAgentNouser(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/agent/banner/nouser"), data, {
    method
  });
}

// 代理banner -- banner上架
function bannerAgentUse(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/agent/banner/user"), data, {
    method
  });
}

// 查询本人的模块页面
function permissionModule(data, method) {
  return ajax("get", getRequestUrl("/v1/manager/permission/module"), data, {
    method
  });
}

// 表情管理
//  获取列表
function getemoji(data, method) {
  return ajax("get", getRequestUrl("/v1/mic/emoji/page"), data, {
    method
  });
}
//  上下架
function emojiSwitch(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/mic/emoji/switch"), data, {
    method
  });
}

//  增加表情
function postEmoji(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/mic/emoji"), data, {
    method
  });
}
//  修改表情
function putEmoji(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/mic/emoji"), data, {
    method
  });
}

//  修改表情
function getCyclestats(data, method) {
  return ajax("get", getRequestUrl("/v1/match/cycle/stats"), data, {
    method
  });
}

//
// 查询群主题
function getGroupTheme(data, method) {
  return ajax("get", getRequestUrl("/v1/groupTheme/"), data, {
    method
  });
}
//
// 查询群主题 上下架
function putGroupThemeSwitch(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/groupTheme/switch"), data, {
    method
  });
}

// 查询群主题 新增
function postGroupTheme(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/groupTheme"), data, {
    method
  });
}

// 查询群主题 修改
function putGroupTheme(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/groupTheme"), data, {
    method
  });
}
// 查询-头饰
function getHeadwear(data, method) {
  return ajax("get", getRequestUrl("/v1/headwear/"), data, {
    method
  });
}

//  查询-头饰 修改
function putHeadwear(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/headwear"), data, {
    method
  });
}
//  查询-头饰 新增
function postHeadwear(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/headwear"), data, {
    method
  });
}
//  查询-头饰 上架
function putHeadwearon(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/headwear/shop/in"), data, {
    method
  });
}
//  查询-头饰 上架
function putHeadwearout(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/headwear/shop/out"), data, {
    method
  });
}
//  查询-头饰 列表 获取所有该用户的道具配置
function getHeadwearUser(data, method) {
  return ajax("get", getRequestUrl(`/v1/headwear/user/${method.id}`), data, {
    method
  });
}

//  查询-头饰 移出
function postHeadwearRemove(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/headwear/user/remove"), data, {
    method
  });
}
//  查询-头饰 -添加用户
function postHeadwearUser(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/headwear/user"), data, {
    method
  });
}

// 查询-勋章
function getMedal(data, method) {
  return ajax("get", getRequestUrl("/v1/medal/"), data, {
    method
  });
}

//  查询-勋章 修改
function putMedal(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/medal"), data, {
    method
  });
}
//  查询-勋章 新增
function postMedal(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/medal"), data, {
    method
  });
}
//  查询-勋章 列表 获取所有该用户的道具配置
function getMedalUser(data, method) {
  return ajax("get", getRequestUrl("/v1/medal/user"), data, {
    method
  });
}

//  查询-勋章 移出
function postMedalRemove(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/medal/remove"), data, {
    method
  });
}
//  查询-勋章添加用户
function postMedalUser(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/medal/add"), data, {
    method
  });
}

// --
// 查询-铭牌
function getNameplate(data, method) {
  return ajax("get", getRequestUrl("/v1/nameplate/"), data, {
    method
  });
}

//  查询-铭牌 修改
function putNameplate(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/nameplate"), data, {
    method
  });
}
//  查询-铭牌 新增
function postNameplate(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/nameplate"), data, {
    method
  });
}
//  查询-铭牌 列表 查询拥有铭牌的用户
function getNameplateUser(data, method) {
  return ajax("get", getRequestUrl("/v1/nameplate/user"), data, {
    method
  });
}

//  查询-铭牌 移除某个用户的铭牌
function postNameplateRemove(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/nameplate/remove"), data, {
    method
  });
}
//  查询-给用户添加铭牌
function postNameplateUser(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/nameplate/add"), data, {
    method
  });
}
// --

//  公会用户管理-扣除豆子
function postBeanReduce(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/bean/reduce"), data, {
    method
  });
}

//  公会用户管理-扣除金币记录
function getGuildUserGold(data, method) {
  return ajax("get", getRequestUrl("/v1/guildUser/gold"), data, {
    method
  });
}

//  公会用户管理-扣除豆子记录
function getGuildUserBean(data, method) {
  return ajax("get", getRequestUrl("/v1/guildUser/bean"), data, {
    method
  });
}

//  用户信息管理-修改用户头像
function putUserAvatar(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/user/avatar"), data, {
    method
  });
}

//  用户信息管理-修改用户国家
function putUserCountry(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/user/country"), data, {
    method
  });
}

//  用户信息管理-ip
function getIpSame(data, method) {
  return ajax("get", getRequestUrl("/v1/user/ip/same"), data, {
    method
  });
}
//  ip账号统计
function getIpStatistics(data, method) {
  return ajax("get", getRequestUrl("/v1/user/ip/same/cnt"), data, {
    method
  });
}
//  用户信息管理-同设备账号数
function getImeiSame(data, method) {
  return ajax("get", getRequestUrl("/v1/user/imei/same"), data, {
    method
  });
}
//  imei账号统计
function getImeiStatistics(data, method) {
  return ajax("get", getRequestUrl("/v1/user/imei/same/cnt"), data, {
    method
  });
}

//  用户信息管理-豆子收入明细
function getUserIncome(data, method) {
  return ajax("get", getRequestUrl("/v1/user/income"), data, {
    method
  });
}

//  用户信息管理-ip-冻结全部
function postUserIpDeal(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/user/ip/deal"), data, {
    method
  });
}

//  用户信息管理-钻石冻结
function putCcountFrozen(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/diamond/account/frozen"), data, {
    method
  });
}

//  用户信息管理-钻石解冻
function putCcountNormal(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/diamond/account/normal"), data, {
    method
  });
}

//  群组支持-查询群组支持详情
function getGroupSupport(data, method) {
  return ajax("get", getRequestUrl("/v1/groupSupport/detail"), data, {
    method
  });
}

//  群组支持-查询群组支持统计
function getGroupSupportStats(data, method) {
  return ajax("get", getRequestUrl("/v1/groupSupport/stats"), data, {
    method
  });
}

// 女孩扶持--数据查询
function getGirlList(data, method) {
  return ajax("get", getRequestUrl("/v1/girlSupport/page"), data, {
    method
  });
}
// 女孩扶持--获取审核列表
function getAuditList(data, method) {
  return ajax("get", getRequestUrl("/v1/girlSupport/audit"), data, {
    method
  });
}
// 女孩扶持--审核
function getAuditOperation(data, method) {
  return ajax("post", getRequestUrl("/v1/girlSupport/audit"), data, {
    method
  });
}

//  钻石发放-查询记录
function getBillpage(data, method) {
  return ajax("get", getRequestUrl("/v1/diamond/bill/page"), data, {
    method
  });
}
// 钻石发放-上传文件
function uploadDiamondbill(data) {
  return uploadImg(getRequestUrl("/v1/mgr/diamond/bill"), data);
}
// 钻石发放-确认发放
function putDiamondbill(data) {
  return ajax("put", getRequestUrl("/v1/mgr/diamond/bill"), data);
}

//  游戏币发放-查询记录
function getYXBPage(data, method) {
  return ajax("get", getRequestUrl("/v1/diamondPink/bill/page"), data, {
    method
  });
}
// 游戏币发放-上传文件
function uploadGameBill(data) {
  return uploadImg(getRequestUrl("/v1/mgr/diamondPink/bill"), data);
}
// 游戏币发放-确认发放
function putGameBill(data) {
  return ajax("put", getRequestUrl("/v1/mgr/diamondPink/bill"), data);
}
//  贵族发放-查询记录
function getBatchPage(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/noble/user/batch"), data, {
    method
  });
}
// 贵族发放-上传文件
function uploadDiamondBatch(data) {
  return uploadImg(getRequestUrl("/v1/mgr/noble/user/batch"), data);
}

// 贵族发放-确认发放
function putDiamondBatch(data) {
  return ajax("put", getRequestUrl("/v1/mgr/noble/user/batch"), data);
}

//  道具发放-查询记录
function getPropsPage(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/user/bag/send/batch"), data, {
    method
  });
}
// 道具发放-上传文件
function uploadPropsBatch(data) {
  return uploadImg(getRequestUrl("/v1/mgr/user/bag/send/batch"), data);
}

// 道具发放-确认发放
function putPropsBatch(data) {
  return ajax("put", getRequestUrl("/v1/mgr/user/bag/send/batch"), data);
}

// 代理黄钻-上传文件
function uploadPropsBatchY(data) {
  return uploadImg(getRequestUrl("/v1/mgr/dealer/diamond/batch"), data);
}

// 代理黄钻-确认发放
function putPropsBatchY(data) {
  return ajax("put", getRequestUrl("/v1/mgr/dealer/diamond/batch"), data);
}

// 推广员-上传文件
function uploadPromotionBatch(data) {
  return uploadImg(getRequestUrl("/v1/mgr/promotion/invite/batch"), data);
}

//  国家管理-查询记录
function getGrouppowerpage(data, method) {
  return ajax("get", getRequestUrl("/v1/groupPower/page"), data, {
    method
  });
}

//  国家管理-新增
function postGrouppower(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/groupPower"), data, {
    method
  });
}
//  国家管理-修改
function putGrouppower(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/groupPower"), data, {
    method
  });
}
//  国家管理-查询记录
function putgroupPowerStatus(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/groupPower/status"), data, {
    method
  });
}
// 国家管理-国家势力解散
function postDissolve(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/groupPower/dissolve"), data, {
    method
  });
}

//  设备-增加设备限制
function postImei(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/imei"), data, {
    method
  });
}

//  设备-删除设备限制
function deleteImei(data, method) {
  return ajax("delete", getRequestUrl(`/v1/mgr/imei/${method.imei}`), data, {
    method
  });
}

//  查询-道具 上架
function putPropertyon(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/property/shop/in"), data, {
    method
  });
}
//  查询-道具 上架
function putPropertyout(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/property/shop/out"), data, {
    method
  });
}

// 发现页banner

// banner管理 -- banner列表
function bannerDiscovery(data, method) {
  return ajax("get", getRequestUrl("/v1/discovery/banner/page"), data, {
    method
  });
}

// banner管理 -- 编辑banner
function bannerDiscoveryEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/discovery/banner"), data, {
    method
  });
}

// banner管理 -- 添加banner
function bannerDiscoveryAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/discovery/banner"), data, {
    method
  });
}

// banner管理 -- banner下架
function bannerDiscoveryNouser(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/discovery/banner/nouser"), data, {
    method
  });
}

// banner管理 -- banner上架
function bannerDiscoveryUse(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/discovery/banner/user"), data, {
    method
  });
}

// 游戏中心banner

// banner管理 -- banner列表
function bannerGame(data, method) {
  return ajax("get", getRequestUrl("/v1/banner/game/act"), data, {
    method
  });
}

// banner管理 -- 编辑banner
function bannerGameEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/banner/game/act"), data, {
    method
  });
}

// banner管理 -- 添加banner
function bannerGameAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/banner/game/act"), data, {
    method
  });
}

// banner管理 -- banner下架
function bannerGameNouser(data, method) {
  return ajax("put", getRequestUrl("/v1/banner/game/act"), data, {
    method
  });
}

// banner管理 -- banner上架
function bannerGameUse(data, method) {
  return ajax("put", getRequestUrl("/v1/banner/game/act"), data, {
    method
  });
}

// 闪屏（接口是：开屏）

// 广告管理 -- 闪屏列表
function openFlashScreen(data, method) {
  return ajax("get", getRequestUrl("/v1/openScreen/page"), data, {
    method
  });
}
// 广告管理 -- 闪屏编辑
function openEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/openScreen"), data, {
    method
  });
}

// 广告管理 -- 闪屏添加
function openAdd(data, method) {
  return ajax("POST", getRequestUrl("/v1/mgr/openScreen"), data, {
    method
  });
}

// 广告管理 -- 闪屏下架
function openNouser(data, method) {
  return ajax("POST", getRequestUrl("/v1/mgr/openScreen/nouse"), data, {
    method
  });
}

// 广告管理 -- 闪屏上架
function openUse(data, method) {
  return ajax("POST", getRequestUrl("/v1/mgr/openScreen/use"), data, {
    method
  });
}

// 运营弹窗（接口是：闪屏）

// 广告管理 -- 运营弹窗列表
function advertisingFlashScreen(data, method) {
  return ajax("get", getRequestUrl("/v1/splashScreen/page"), data, {
    method
  });
}
// 广告管理 -- 运营弹窗编辑
function advertisingEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/splashScreen"), data, {
    method
  });
}

// 广告管理 -- 运营弹窗添加
function advertisingAdd(data, method) {
  return ajax("POST", getRequestUrl("/v1/mgr/splashScreen"), data, {
    method
  });
}

// 广告管理 -- 运营弹窗下架
function advertisingNouser(data, method) {
  return ajax("POST", getRequestUrl("/v1/mgr/splashScreen/nouse"), data, {
    method
  });
}

// 广告管理 -- 运营弹窗上架
function advertisingUse(data, method) {
  return ajax("POST", getRequestUrl("/v1/mgr/splashScreen/use"), data, {
    method
  });
}

// 新用户邀请审核
// 新用户邀请审核 -- 新用户活动奖励（批量通过或拒绝）
function newUserInvite(data, method) {
  return ajax("POST", getRequestUrl("/v1/mgr/activity/newUserInvite"), data, {
    method
  });
}
// 新用户邀请审核 -- 用户邀请列表
function newUserList(data, method) {
  return ajax("get", getRequestUrl("/v1/newUserActivity/invite/list"), data, {
    method
  });
}
// 新用户邀请审核 -- 邀请结果统计
function resultStatistics(data, method) {
  return ajax(
    "get",
    getRequestUrl(`/v1/newUserActivity/invite/stats/${data.period}`),
    data,
    {
      method
    }
  );
}
// 新用户邀请审核 -- 邀请通过统计
function newUserStatistics(data, method) {
  return ajax(
    "get",
    getRequestUrl(`/v1/newUserActivity/invite/summary/${data.period}`),
    data,
    {
      method
    }
  );
}
// 新用户邀请审核 -- 用户审核状态列表
function newUserState(data, method) {
  return ajax("get", getRequestUrl("/v1/newUserActivity/list"), data, {
    method
  });
}

// 群组活动奖励审核
// 群组活动奖励审核 -- 群组活动奖励（批量通过或拒绝）
function newGroupInvite(data, method) {
  return ajax("PUT", getRequestUrl("/v1/mgr/group/activity"), data, {
    method
  });
}
function groupAuditList(data, method) {
  return ajax("get", getRequestUrl("/v1/group/activity"), data, {
    method
  });
}
// 群组活动统计
function groupAuditStatistics(data, method) {
  return ajax("get", getRequestUrl("/v1/group/activity/stat"), data, {
    method
  });
}

// 金币数据统计
function goldList(data, method) {
  return ajax("get", getRequestUrl(`/v1/gold/sum/${data.period}`), data, {
    method
  });
}

// 充值代理管理 -- 新增促销员
function selectPromoter(data, method) {
  return ajax("get", getRequestUrl(`/v1/mgr/dl/promoter/${data.code}`), data, {
    method
  });
}
// 充值代理管理 -- 编辑促销员
function editPromoter(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/dl/promoter"), data, {
    method
  });
}

// 充值代理管理 -- 查询币商信息
function dealerList(data, method) {
  return ajax("get", getRequestUrl("/v1/dealer/"), data, {
    method
  });
}
// 用户 -- 国家列表
function getDealerCountryList(data, method, aa) {
  return ajax("get", getRequestUrl("/v1/user/country", aa), data, {
    method
  });
}
// 充值代理管理 -- 查询币商充值记录
function dealerChargeList(data, method) {
  return ajax("get", getRequestUrl("/v1/dealer/charge"), data, {
    method
  });
}
// 充值代理管理 -- 查询币商小结
function dealerSummaryList(data, method) {
  return ajax("get", getRequestUrl("/v1/dealer/summary"), data, {
    method
  });
}
// 充值代理管理 -- 销售明细
function detailList(data, method) {
  return ajax("get", getRequestUrl("/v1/dealer/transfer"), data, {
    method
  });
}
// 充值代理管理 -- 分销明细
function distributionDetailList(data, method) {
  return ajax("get", getRequestUrl("/v1/dealer/shift/list"), data, {
    method
  });
}
// 充值代理管理 -- 新增代理
function agentCreate(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/dealer"), data, {
    method
  });
}
// 充值代理管理 -- 代理修改（接口暂缺）
// function agentUpdate(data, method) {
//   return ajax('put', getRequestUrl('/v1/mgr/gift/edit'), data, {
//     method,
//   });
// }
// 充值代理管理 -- 代理下架
function agentSwitch(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/dealer/status"), data, {
    method
  });
}
// 充值代理管理 -- 代理充值
function agentCurrency(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/dealer/diamond"), data, {
    method
  });
}
// 充值代理管理 -- 币商上架到国家(新增)
function countrySave(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/dealer/country"), data, {
    method
  });
}
// 充值代理管理 -- 查询币商上架到哪些国家(编辑)
function countryList(data, method) {
  return ajax("get", getRequestUrl("/v1/dealer/country"), data, {
    method
  });
}

// 充值代理管理 -- 二级代理列表
function secondList(data, method) {
  return ajax("get", getRequestUrl("/v1/dealer/second"), data, {
    method
  });
}
// 充值代理管理 -- 二级代理（创建）（编辑）
function secondAddOrEdit(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/dealer/second"), data, {
    method
  });
}

// 活动管理 -- 周星活动 -- 列表
function giftList(data, method) {
  return ajax("get", getRequestUrl("/v1/weeklyGift/"), data, {
    method
  });
}
// 活动管理 -- 周星活动 -- 新增/修改
function weekGiftCreate(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/weeklyStarGift"), data, {
    method
  });
}

// 玩法管理 -- 幸运盒子 -- 奖励列表
function getPrizePage(data, method) {
  return ajax("get", getRequestUrl("/v1/luckybox/award/page"), data, {
    method
  });
}

// 玩法管理 -- 幸运盒子 -- 抽奖统计
function getPrizeDraw(data, method) {
  return ajax("get", getRequestUrl("/v1/luckybox/award/count/page"), data, {
    method
  });
}

// 玩法管理 -- 幸运盒子 -- 抽奖明细
function getPrizeDetail(data, method) {
  return ajax("get", getRequestUrl("/v1/luckybox/award/detail/page"), data, {
    method
  });
}

// 玩法管理 -- 幸运盒子 -- 编辑奖品
function getPrizeEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/luckybox/award"), data, {
    method
  });
}

// 玩法管理 -- 幸运盒子 -- 添加奖品
function getPrizeAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/luckybox/award"), data, {
    method
  });
}

//  玩法管理 -- 幸运盒子 上架
function prizeUse(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/luckybox/award/use"), data, {
    method
  });
}
//  玩法管理 -- 幸运盒子 下架
function prizeUseNo(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/luckybox/award/useno"), data, {
    method
  });
}

// ---------------------------
// 玩法管理 -- H5幸运盒子 -- 高级奖励列表
function getPrizePageH5(data, method) {
  return ajax("get", getRequestUrl("/v1/luckybox/h5/award/page"), data, {
    method
  });
}

// 玩法管理 -- H5幸运盒子 -- 高级抽奖统计
function getPrizeDrawH5(data, method) {
  return ajax("get", getRequestUrl("/v1/luckybox/h5/award/count/page"), data, {
    method
  });
}

// 玩法管理 -- H5幸运盒子 -- 高级抽奖明细
function getPrizeDetailH5(data, method) {
  return ajax("get", getRequestUrl("/v1/luckybox/h5/award/detail/page"), data, {
    method
  });
}

// 玩法管理 -- H5幸运盒子 -- 高级编辑奖品
function getPrizeEditH5(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/luckybox/h5/award"), data, {
    method
  });
}

// 玩法管理 -- H5幸运盒子 -- 高级添加奖品
function getPrizeAddH5(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/luckybox/h5/award"), data, {
    method
  });
}

//  玩法管理  -- H5幸运盒子 -- 高级上架
function prizeUseH5(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/luckybox/h5/award/use"), data, {
    method
  });
}
//  玩法管理 -- H5幸运盒子 -- 高级下架
function prizeUseNoH5(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/luckybox/h5/award/useno"), data, {
    method
  });
}
//  玩法管理 -- H5幸运盒子 奖励榜单
function boxAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/luckybox/h5/rank/award"), data, {
    method
  });
}
//  玩法管理 -- H5幸运盒子 投注榜单
function boxStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/luckybox/h5/rank/stake"), data, {
    method
  });
}
// ---------------------------

//  活动管理 -- 群组对战 查询群组PK
function groupPKList(data, method) {
  return ajax("get", getRequestUrl("/v1/activity/groupPK/page"), data, {
    method
  });
}

//  活动管理 -- 群组对战 群组PK详情
function groupPKDetail(data, method) {
  return ajax("get", getRequestUrl("/v1/activity/groupPK/detail/page"), data, {
    method
  });
}

//  活动管理 -- 群组对战 群组PK活动-删除PK组
function groupPKDel(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/activity/pk/del"), data, {
    method
  });
}

//  活动管理 -- 群组对战 群组PK活动-更新PK组
function groupPKUpdate(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/activity/pk/group"), data, {
    method
  });
}

//  活动管理 -- 群组对战 群组PK活动-增加PK组
function groupPKAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/activity/pk/group"), data, {
    method
  });
}

//  活动管理 -- 群组对战 群组PK活动-上架
function pkUse(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/activity/pk/use"), data, {
    method
  });
}
//  活动管理 -- 群组对战 群组PK活动-下架
function pkUseNo(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/activity/pk/nouse"), data, {
    method
  });
}

//  活动管理 -- 群组对战 群组PK活动奖励
function groupPKAward(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/activity/pk/group/award"), data, {
    method
  });
}

//  活动管理 -- 群组对战 群组PK活动-增加PK组excel
function groupPKExcel(data, method) {
  return uploadImg(getRequestUrl("/v1/mgr/activity/pk/group/excel"), data);
}

//  玩法管理 -- 水果机 日统计
function statisticsList(data, method) {
  return ajax("get", getRequestUrl("/v1/fruitMachine/day/stats"), data, {
    method
  });
}
//  玩法管理 -- 水果机 日明细
function dayDetailList(data, method) {
  return ajax("get", getRequestUrl("/v1/fruitMachine/day/detail"), data, {
    method
  });
}
//  玩法管理 -- 水果机--用户明细 奖励榜单
function dayAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/fruitMachine/rank/award"), data, {
    method
  });
}
//  玩法管理 -- 水果机--用户明细 投注榜单
function dayStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/fruitMachine/rank/stake"), data, {
    method
  });
}

//  玩法管理 -- 水果机 利润榜单-升序
function gameFruitsAsc(data, method) {
  return ajax("get", getRequestUrl("/v1/fruitMachine/rank/profit/asc"), data, {
    method
  });
}
//  玩法管理 -- 水果机 利润榜单-降序
function gameFruitsDesc(data, method) {
  return ajax("get", getRequestUrl("/v1/fruitMachine/rank/profit/desc"), data, {
    method
  });
}
//  玩法管理 -- 水果机 脚本管理-列表
function gameFruitsScriptList(data, method) {
  return ajax("get", getRequestUrl("/v1/fruitMachine/script/list"), data, {
    method
  });
}
//  玩法管理 -- 水果机 脚本管理-执行列表
function gameFruitsScriptExecList(data, method) {
  return ajax("get", getRequestUrl("/v1/fruitMachine/script/exec/list"), data, {
    method
  });
}
//  玩法管理 -- 水果机 脚本管理-添加脚本
function getAddFruitsScript(data, method) {
  return ajax("POST", getRequestUrl("/v1/fruitMachine/script"), data, {
    method
  });
}
//  玩法管理 -- 水果机 脚本管理-删除脚本
function getDeleteFruitsScript(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/fruitMachine/script/${data.id}`),
    data,
    {
      method
    }
  );
}

//  玩法管理 -- slot榜单 奖励榜单
function slotAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/slot/rank/award"), data, {
    method
  });
}
//  玩法管理 -- slot榜单 投注榜单
function slotStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/slot/rank/stake"), data, {
    method
  });
}

//  玩法管理 -- candy榜单 奖励榜单
function candyAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/candy/rank/award"), data, {
    method
  });
}
//  玩法管理 -- candy榜单 投注榜单
function candyStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/candy/rank/stake"), data, {
    method
  });
}

//  玩法管理 -- greedy榜单 奖励榜单
function greedyAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/greedy/rank/award"), data, {
    method
  });
}
//  玩法管理 -- greedy榜单 投注榜单
function greedyStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/greedy/rank/stake"), data, {
    method
  });
}

//  玩法管理 -- 多财多福榜单 日统计
function gameSlotDayList(data, method) {
  return ajax("get", getRequestUrl("/v1/gameSlot/day/stats"), data, {
    method
  });
}
//  玩法管理 -- 多财多福榜单 奖励榜单
function gameSlotAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/gameSlot/rank/award"), data, {
    method
  });
}
//  玩法管理 -- 多财多福榜单 投注榜单
function gameSlotStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/gameSlot/rank/stake"), data, {
    method
  });
}

//  玩法管理 -- 赛车游戏 日统计
function statisticsRaceList(data, method) {
  return ajax("get", getRequestUrl("/v1/race/day/stats"), data, {
    method
  });
}
//  玩法管理 -- 赛车游戏 日明细
function dayRaceDetailList(data, method) {
  return ajax("get", getRequestUrl("/v1/race/day/detail"), data, {
    method
  });
}
//  玩法管理 -- 赛车游戏 奖励榜单
function gameRaceAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/race/rank/award"), data, {
    method
  });
}
//  玩法管理 -- 赛车游戏 投注榜单
function gameRaceStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/race/rank/stake"), data, {
    method
  });
}
//  玩法管理 -- 赛车游戏 利润榜单-升序
function gameRaceStakeAsc(data, method) {
  return ajax("get", getRequestUrl("/v1/race/rank/profit/asc"), data, {
    method
  });
}
//  玩法管理 -- 赛车游戏 利润榜单-降序
function gameRaceStakeDesc(data, method) {
  return ajax("get", getRequestUrl("/v1/race/rank/profit/desc"), data, {
    method
  });
}
//  玩法管理 -- 赛车游戏 脚本管理-列表
function gameRaceScriptList(data, method) {
  return ajax("get", getRequestUrl("/v1/race/script/list"), data, {
    method
  });
}
//  玩法管理 -- 赛车游戏 脚本管理-执行列表
function gameRaceScriptExecList(data, method) {
  return ajax("get", getRequestUrl("/v1/race/script/exec/list"), data, {
    method
  });
}
//  玩法管理 -- 赛车游戏 脚本管理-添加脚本
function getAddScript(data, method) {
  return ajax("POST", getRequestUrl("/v1/race/script"), data, {
    method
  });
}
//  玩法管理 -- 赛车游戏 脚本管理-删除脚本
function getDeleteScript(data, method) {
  return ajax("delete", getRequestUrl(`/v1/race/script/${data.id}`), data, {
    method
  });
}
//  玩法管理 -- 埃及slot 日统计
function statisticsEgyptList(data, method) {
  return ajax("get", getRequestUrl("/v1/egyptSlot/day/stats"), data, {
    method
  });
}
//  玩法管理 -- 埃及slot 奖励榜单
function EgyptAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/egyptSlot/rank/award"), data, {
    method
  });
}
//  玩法管理 -- 埃及slot 投注榜单
function EgyptStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/egyptSlot/rank/stake"), data, {
    method
  });
}

//  玩法管理 -- 捕鱼游戏 日统计
function statisticsFishList(data, method) {
  return ajax("get", getRequestUrl("/v1/fish/day/stats"), data, {
    method
  });
}
//  玩法管理 -- 捕鱼游戏 奖励榜单
function FishAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/fish/rank/award"), data, {
    method
  });
}
//  玩法管理 -- 捕鱼游戏 投注榜单
function FishStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/fish/rank/stake"), data, {
    method
  });
}

//  玩法管理 -- 足球slot 日统计
function statisticsFootballList(data, method) {
  return ajax("get", getRequestUrl("/v1/footballSlot/day/stats"), data, {
    method
  });
}
//  玩法管理 -- 足球slot 奖励榜单
function FootballAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/footballSlot/rank/award"), data, {
    method
  });
}
//  玩法管理 -- 足球slot 投注榜单
function FootballStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/footballSlot/rank/stake"), data, {
    method
  });
}

/////////////////////////////////////
//  玩法管理 -- 女巫slot 日统计
function statisticsWitchList(data, method) {
  return ajax("get", getRequestUrl("/v1/witchSlot/day/stats"), data, {
    method
  });
}
//  玩法管理 -- 女巫slot 奖励榜单
function WitchAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/witchSlot/rank/award"), data, {
    method
  });
}
//  玩法管理 -- 女巫slot 投注榜单
function WitchStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/witchSlot/rank/stake"), data, {
    method
  });
}

//  玩法管理 -- teenparty 日统计
function statisticsTeenpList(data, method) {
  return ajax("get", getRequestUrl("/v1/teenpatti/day/stats"), data, {
    method
  });
}
//  玩法管理 -- teenparty 奖励榜单
function TeenpAwardList(data, method) {
  return ajax("get", getRequestUrl("/v1/teenpatti/rank/award"), data, {
    method
  });
}
//  玩法管理 -- teenparty 投注榜单
function TeenpStakeList(data, method) {
  return ajax("get", getRequestUrl("/v1/teenpatti/rank/stake"), data, {
    method
  });
}
//////////////////////////////////////////////////
//  玩法管理 --  foodie游戏 日统计
function statisticsFoodieList(data, method) {
  return ajax("get", getRequestUrl("/v1/foodie/day/stats"), data, {
    method
  });
}
//  玩法管理 --  foodie游戏 日明细
function dayDetailFoodieList(data, method) {
  return ajax("get", getRequestUrl("/v1/foodie/day/detail"), data, {
    method
  });
}
//  玩法管理 --  foodie游戏--用户明细 奖励榜单
function dayAwardFoodieList(data, method) {
  return ajax("get", getRequestUrl("/v1/foodie/rank/award"), data, {
    method
  });
}
//  玩法管理 --  foodie游戏--用户明细 投注榜单
function dayStakeFoodieList(data, method) {
  return ajax("get", getRequestUrl("/v1/foodie/rank/stake"), data, {
    method
  });
}
//  玩法管理 --  foodie游戏 利润榜单-升序
function gameFoodieAsc(data, method) {
  return ajax("get", getRequestUrl("/v1/foodie/rank/profit/asc"), data, {
    method
  });
}
//  玩法管理 --  foodie游戏 利润榜单-降序
function gameFoodieDesc(data, method) {
  return ajax("get", getRequestUrl("/v1/foodie/rank/profit/desc"), data, {
    method
  });
}
//////////////////////////////////////////////////

//  活动管理 -- 水果大亨统计
function bigwigList(data, method) {
  return ajax("get", getRequestUrl("/v1/fruitMachine/tycoon/stats"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 查询活动1
function getTemplateAct(data, method) {
  return ajax("get", getRequestUrl("/v1/actMgr/actRecord/list"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 添加活动1
function getAddTemplateAct(data, method) {
  return ajax("post", getRequestUrl("/v1/actMgr/actRecord"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 编辑活动1
function getEditTemplateAct(data, method) {
  return ajax("put", getRequestUrl("/v1/actMgr/actRecord"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 删除活动1
function delTemplateAct(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/actMgr/actRecord/${data.id}`),
    data,
    {
      method
    }
  );
}
//  活动管理 -- 活动配置 -- 复制活动1
function getCopyAct(data, method) {
  return ajax("post", getRequestUrl("/v1/actMgr/actRecord/copy"), data, {
    method
  });
}
// 活动管理 -- 活动配置 -- 活动礼物列表1
function getGiftAct(data, method) {
  return ajax("get", getRequestUrl("/v1/actMgr/actGift/config/list"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 活动礼物编辑1
function getUpdateGiftAct(data, method) {
  return ajax("put", getRequestUrl("/v1/actMgr/actGift/config/"), data, {
    method
  });
}

//  活动管理 -- 活动配置 -- 查询活动任务1
function getTaskAct(data, method) {
  return ajax("get", getRequestUrl("/v1/actMgr/actTask/config/list"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 添加任务1
function getAddTaskAct(data, method) {
  return ajax("post", getRequestUrl("/v1/actMgr/actTask/config/"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 编辑任务1
function getEditTaskAct(data, method) {
  return ajax("put", getRequestUrl("/v1/actMgr/actTask/config/"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 删除任务1
function delTaskAct(data, method) {
  return ajax(
    "delete",
    getRequestUrl(
      `/v1/actMgr/actTask/config/${data.activityId}/${data.taskId}`
    ),
    data,
    {
      method
    }
  );
}
//  活动管理 -- 活动配置 -- 复制任务1
function getCopyTaskAct(data, method) {
  return ajax("post", getRequestUrl("/v1/actMgr/actTask/config/copy"), data, {
    method
  });
}

//  活动管理 -- 活动配置 -- 任务 -- 奖励1
function getAwardAct(data, method) {
  return ajax("get", getRequestUrl("/v1/actMgr/actAward/config/list"), data, {
    method
  });
}
//  活动管理 -- 活动配置  -- 任务 -- 添加奖励1
function getAddAwardAct(data, method) {
  return ajax("post", getRequestUrl("/v1/actMgr/actAward/config"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 任务  -- 编辑奖励1
function getEditAwardAct(data, method) {
  return ajax("put", getRequestUrl("/v1/actMgr/actAward/config"), data, {
    method
  });
}
//  活动管理 -- 活动配置 -- 任务  -- 删除奖励1
function delAwardAct(data, method) {
  return ajax(
    "delete",
    getRequestUrl(
      `/v1/actMgr/actAward/config/${data.activityId}/${data.taskId}/${data.n}`
    ),
    data,
    {
      method
    }
  );
}

// 活动管理 -- 选手名单 -- 上传选手名单1
function uploadTeamUser(data) {
  return uploadImg(getRequestUrl("/v1/actMgr/actTeam/user/excelCreate"), data);
}
// 活动管理 -- 选手名单 -- 获取活动队伍1
function getTeamUser(data, method) {
  return ajax("get", getRequestUrl("/v1/actMgr/actTeam/user/list"), data, {
    method
  });
}
// 活动管理 -- 选手名单 -- 修改活动队伍1
function putTeamUser(data, method) {
  return ajax("put", getRequestUrl("/v1/actMgr/actTeam/user"), data, {
    method
  });
}
// 活动管理 -- 选手名单 -- 名单下载1
function downloadRank(data, method) {
  return ajax("get", getRequestUrl("/v1/actMgr/actRank/list"), data, {
    method
  });
}

// 活动管理 -- 活动补票 -- 列表【/v1/templateAct/sendBallot】
function getListAct(data, method) {
  return ajax("get", getRequestUrl("/v1/templateAct/sendBallot"), data, {
    method
  });
}
// 活动管理 -- 活动补票 -- 确认补票【/v1/templateAct/sendBallot】
function getMendAct(data, method) {
  return ajax("post", getRequestUrl("/v1/templateAct/sendBallot"), data, {
    method
  });
}
//  用户充值管理 -- 列表
function getUserRecharge(data, method) {
  return ajax("get", getRequestUrl("/v1/stats/charge/user"), data, {
    method
  });
}

// 风险管理--退款明细
function refundDetail(data, method) {
  return ajax("get", getRequestUrl("/v1/risk/refund/detail"), data, {
    method
  });
}
// 风险管理--充值黑白名单
function whiteBlackDetail(data, method) {
  return ajax("get", getRequestUrl("/v1/risk/whiteBlack"), data, {
    method
  });
}
// 风险管理--充值黑白名单--新增
function whiteBlackAdd(data, method) {
  return ajax("post", getRequestUrl("/v1/risk/whiteBlack"), data, {
    method
  });
}
// 风险管理--充值黑白名单--编辑
function whiteBlackEdit(data, method) {
  return ajax("put", getRequestUrl("/v1/risk/whiteBlack"), data, {
    method
  });
}
// 风险管理--充值黑白名单--删除
function delRollAct(data, method) {
  return ajax("delete", getRequestUrl(`/v1/risk/whiteBlack/${data.id}`), data, {
    method
  });
}
// 风险管理--退款统计
function refundSummary(data, method) {
  return ajax(
    "get",
    getRequestUrl(`/v1/risk/refund/summary/${data.period}`),
    data,
    {
      method
    }
  );
}

// 推广管理
// 推广管理 -- 列表
function getTeamList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/promotion/teams/data"), data, {
    method
  });
}
// 推广管理 -- 解散团队
function getDeleteTeam(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/promotion/team/${data.id}`),
    data,
    {
      method
    }
  );
}
// 推广管理 -- 修改经理ID
function amendIDFun(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/promotion/changeManager"), data, {
    method
  });
}
// 推广管理 -- 获取团队信息
function getSelectList(data, method) {
  return ajax("get", getRequestUrl(`/v1/mgr/promotion/team/${data.id}`), data, {
    method
  });
}
//  推广管理 --- 新增团队
function addTeam(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/promotion/team"), data, {
    method
  });
}
//  推广管理 --- 编辑团队
function editTeam(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/promotion/team"), data, {
    method
  });
}
//  推广管理 --- 推送欢迎派对小助手 -- 参数：id：推广id，type：0取消，1推送
function pushMsgTeam(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/promotion/pushMsg"), data, {
    method
  });
}

// 推广管理 -- 推广邀请数据列表
function getInviteList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/promotion/invite/data"), data, {
    method
  });
}
//  推广管理 --- 绑定邀请关系
function addBound(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/promotion/invite"), data, {
    method
  });
}
// 推广管理 -- 解除绑定关系
function delBound(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/promotion/invite/${data.id}`),
    data,
    {
      method
    }
  );
}
// 推广管理 -- 选择平台
function getPlatform(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/promotion/platform"), data, {
    method
  });
}
// 推广管理 -- 派对审核--列表
function getInviteParty(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/invite/apply"), data, {
    method
  });
}
// 推广管理 -- 派对审核--审核
function getPartyAudit(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/invite/apply"), data, {
    method
  });
}

// 推广管理 -- 邀请数据中心 --列表
function getInvitePartyCenter(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/invite/apply/ksa"), data, {
    method
  });
}
// 推广管理 -- 邀请数据中心 --审核
function getPartyAuditCenter(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/invite/apply/ksa"), data, {
    method
  });
}

// 推广管理 -- 邀请数据中心 --充值奖励发放
function getChargeAward(data, method) {
  return ajax(
    "post",
    getRequestUrl("/v1/mgr/invite/apply/ksa/chargeAward"),
    data,
    {
      method
    }
  );
}

// 真人认证审核 -- 列表
function getCer(data, method) {
  return ajax("get", getRequestUrl("/v1/user/realCertification/page"), data, {
    method
  });
}
// 真人认证审核 -- 审核
function getPartyAuditCer(data, method) {
  return ajax(
    "post",
    getRequestUrl("/v1/user/realCertification/review"),
    data,
    {
      method
    }
  );
}

// 操作日志管理-- 操作日志记录列表
function getOperation(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/operation/page"), data, {
    method
  });
}
// 操作日志管理-- 获取模块
function getModal(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/operation/module"), data, {
    method
  });
}
// 绑定手机-- 获取手机号
function getIphone(data, method) {
  return ajax("get", getRequestUrl("/v1/user/phone"), data, {
    method
  });
}
// 绑定手机
function bangDingIphone(data, method) {
  return ajax("post", getRequestUrl("/v1/user/phone"), data, {
    method
  });
}
// 查询区号
function getArea(data, method) {
  return ajax("get", getRequestUrl("/v1/h5/res/country"), data, {
    method
  });
}

// 获取版本列表
function getVersions(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/versionControl"), data, {
    method
  });
}
// 编辑版本
function getEditVersions(data, method) {
  return ajax("put", getRequestUrl("/v1/mgr/versionControl"), data, {
    method
  });
}

// 获取genToken
function genToken(data, method) {
  return ajax("get", getRequestUrl("/v1/inner/genToken"), data, {
    method
  });
}

// Echarts图表图形 -- 日充统计图
function getCac(data, method) {
  return ajax("get", getRequestUrl("/v1/dashboard/day/charge"), data, {
    method
  });
}
//
// Echarts图表图形 -- 日活统计图
function getDayUser(data, method) {
  return ajax("get", getRequestUrl("/v1/dashboard/day/user"), data, {
    method
  });
}
// 黑名单
// 获取黑名单列表
function getBlackList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/activity/blackList"), data, {
    method
  });
}
// 新增黑名单列表
function postBlackList(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/activity/blackList"), data, {
    method
  });
}
// 删除黑名单用户
function delBlackList(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/activity/blackList/${data.userCode}`),
    data,
    {
      method
    }
  );
}

// 白名单
// 获取白名单列表
function getWhiteList(data, method) {
  return ajax("get", getRequestUrl("/v1/mgr/checkout/email"), data, {
    method
  });
}
// 新增白名单列表
function postWhiteList(data, method) {
  return ajax("post", getRequestUrl("/v1/mgr/checkout/email"), data, {
    method
  });
}
// 删除白名单用户
function delWhiteList(data, method) {
  return ajax(
    "delete",
    getRequestUrl(`/v1/mgr/checkout/email/${data.userCode}`),
    data,
    {
      method
    }
  );
}

export default {
  putBannerRoomStatus,
  putBannerRoom,
  postBannerRoom,
  bannerAgentList,
  bannerAgentEdit,
  bannerAgentAdd,
  bannerAgentNouser,
  bannerAgentUse,
  getBannerRoom,
  bannerDiscovery,
  bannerDiscoveryEdit,
  bannerDiscoveryAdd,
  bannerDiscoveryNouser,
  bannerDiscoveryUse,
  bannerGame,
  bannerGameEdit,
  bannerGameAdd,
  bannerGameNouser,
  bannerGameUse,
  getgroupBanner,
  putPropertyon,
  putPropertyout,
  putHeadwearon,
  putHeadwearout,
  deleteVip,
  deleteImei,
  postImei,
  putGrouppower,
  putgroupPowerStatus,
  postDissolve,
  postGrouppower,
  getGrouppowerpage,
  putDiamondbill,
  uploadDiamondbill,
  getBatchPage,
  getYXBPage,
  uploadGameBill,
  putGameBill,
  uploadDiamondBatch,
  putDiamondBatch,
  getPropsPage,
  uploadPropsBatch,
  putPropsBatch,
  uploadPropsBatchY,
  putPropsBatchY,
  uploadPromotionBatch,
  getBillpage,
  getGroupSupportStats,
  getGirlList,
  getAuditList,
  getAuditOperation,
  getGroupSupport,
  putCcountNormal,
  putCcountFrozen,
  getUserIncome,
  postUserIpDeal,
  getIpSame,
  getIpStatistics,
  getImeiSame,
  getImeiStatistics,
  putUserCountry,
  putUserAvatar,
  postBeanReduce,
  getGuildUserGold,
  getGuildUserBean,
  getMedal,
  putMedal,
  getMedalUser,
  postMedalRemove,
  postMedalUser,
  postMedal,
  viplStatistics,

  postHeadwearUser,
  postHeadwearRemove,
  getHeadwearUser,
  putHeadwear,
  postHeadwear,
  getHeadwear,
  postGroupTheme,
  putGroupTheme,
  putGroupThemeSwitch,
  getGroupTheme,
  getCyclestats,
  postEmoji,
  putEmoji,
  emojiSwitch,
  getemoji,
  login: login,
  loginOut,
  checkAdminPwd,
  exportData: exportData,
  upload,
  getAdminList,
  createAdmin,
  deleteAdmin,
  updateAdmin,
  getPermission,
  editPermission,
  settCountryList,
  setSave,
  setDataSave,
  delDataSave,
  giftIndex,
  giftUpdate,
  giftCreate,
  giftSwitch,
  giftDetail,
  reportFeedbacks,
  reportList,
  reportBanUser,
  reportHandle,
  usersList,
  updateSex,
  userUnionUpdate,
  usersConnects,
  usersPayments,
  usersConsume,
  usersPaymentsCreate,
  usersSendGameMonty,
  statsConsume,
  diamondReduce,
  goldReduce,
  usersVipCreate,
  userSearch,
  userDeal,
  userBroadcast,
  relieveUserBroadcast,
  userTradeUnionDel,
  banDevice,
  unBanDevice,
  getCountryList,
  getCountryArea,
  getCountryListTwo,
  userRecommend,
  unionUserList,
  unionConnectList,
  associationAvatar,
  unionConnectDetail,
  unionConnectStats,
  updateAgentUnion,
  updateAgentName,
  agentListPage,
  addAgentPage,
  editAgentPage,
  deleteAgentPage,
  editAgentMgr,
  deleteAgentMgr,
  setStarchatId,
  matchCyclePage,
  matchCyclePageDetail,
  matchLogSTotalDetail,
  matchLogSRelation,
  matchLogExcellent,
  matchLogRelationTop,
  matchLogSingle,
  matchRpc,
  dailyStatistics,
  monthStatistics,
  totalStatistics,
  weekStatistics,
  rechargeStatistics,
  consumeStatistics,
  recommendPage,
  recommendDel,
  managerPage,
  managerEdit,
  managerAdd,
  managerNoUser,
  agentAll,
  advertiseList,
  advertiseEdit,
  advertiseAdd,
  advertiseSwitch,
  activityList,
  activityEdit,
  activityAdd,
  manageDel,
  resetAvatar,
  getUserPhoto,
  photoDelete,
  updateUserNick,
  updateUserLevel,
  updateUserCode,
  resetUserCode,
  checkProp,
  deleteProp,
  diamondIncomeList,
  deleteAdministration,
  createCode,
  banInterface,
  banRescind,
  propertyEdit,
  propertyAdd,
  propertyAddToUser,
  propertyRemoveToUser,
  propertyList,
  propertyUserList,
  groupList,
  groupAllow,
  groupBan,
  groupOnTop,
  groupOnTopCancel,
  groupProfile,
  groupBeautifulCodePut,
  groupBeautifulCodeDelete,
  getBannerPage,
  addBannerPage,
  editBannerPage,
  deleteBannerPage,

  bannerManagementList,
  bannerManagementEdit,
  bannerManagementAdd,
  bannerManagementNouser,
  bannerManagementUse,

  permissionModule,
  putGrouphide,
  getRoomList,
  getAddCreateAct,
  getUpdateAct,
  actSwitch,
  getExamineList,
  getPrivilegeList,
  getRoomSpecList,
  getAddSpecAct,
  getUpdateSpecAct,
  getCopySpecAct,
  actSpecSwitch,
  getExamineSpeList,
  getTaskSpecAct,
  getAddTaskSpecAct,
  getEditTaskSpecAct,
  delTaskSpecAct,
  getCopyTaskSpecAct,
  getAwardSpecAct,
  getAddAwardSpecAct,
  getEditAwardSpecAct,
  delAwardSpecAct,
  selectPromoter,
  editPromoter,
  dealerList,
  getDealerCountryList,
  dealerChargeList,
  dealerSummaryList,
  agentCreate,
  // agentUpdate,
  agentSwitch,
  agentCurrency,
  detailList,
  distributionDetailList,
  countrySave,
  countryList,
  secondList,
  secondAddOrEdit,
  giftList,
  weekGiftCreate,

  getPrizePage,
  getPrizeDraw,
  getPrizeDetail,
  getPrizeEdit,
  getPrizeAdd,
  // IPCount,
  prizeUse,
  prizeUseNo,

  getPrizePageH5,
  getPrizeDrawH5,
  getPrizeDetailH5,
  getPrizeEditH5,
  getPrizeAddH5,
  // IPCount,
  prizeUseH5,
  prizeUseNoH5,
  boxAwardList,
  boxStakeList,

  advertisingFlashScreen,
  advertisingEdit,
  advertisingAdd,
  advertisingNouser,
  advertisingUse,

  openFlashScreen,
  openEdit,
  openAdd,
  openNouser,
  openUse,

  groupPKList,
  groupPKDetail,
  groupPKDel,
  groupPKUpdate,
  groupPKAdd,
  pkUse,
  pkUseNo,
  groupPKAward,
  groupPKExcel,

  statisticsList,
  dayDetailList,
  dayAwardList,
  dayStakeList,
  gameFruitsAsc,
  gameFruitsDesc,
  gameFruitsScriptList,
  gameFruitsScriptExecList,
  getAddFruitsScript,
  getDeleteFruitsScript,
  slotAwardList,
  slotStakeList,
  candyAwardList,
  candyStakeList,
  greedyAwardList,
  greedyStakeList,
  gameSlotDayList,
  gameSlotAwardList,
  gameSlotStakeList,
  statisticsRaceList,
  dayRaceDetailList,
  gameRaceAwardList,
  gameRaceStakeList,
  gameRaceStakeAsc,
  gameRaceStakeDesc,
  gameRaceScriptList,
  gameRaceScriptExecList,
  getAddScript,
  getDeleteScript,
  addBroadcastAdministrator,
  delBroadcastAdministrator,
  sendNobility,
  sendProps,
  addTradeUnion,
  deleteTradeUnion,
  countryAdministration,

  statisticsEgyptList,
  EgyptAwardList,
  EgyptStakeList,

  statisticsFishList,
  FishAwardList,
  FishStakeList,
  statisticsFootballList,
  FootballAwardList,
  FootballStakeList,

  statisticsWitchList,
  WitchAwardList,
  WitchStakeList,

  statisticsTeenpList,
  TeenpAwardList,
  TeenpStakeList,
  statisticsFoodieList,
  dayDetailFoodieList,
  dayAwardFoodieList,
  dayStakeFoodieList,
  gameFoodieAsc,
  gameFoodieDesc,

  userLeave,
  addManager,
  delManager,
  bigwigList,
  chargePayments,
  refundDetail,
  whiteBlackDetail,
  whiteBlackAdd,
  whiteBlackEdit,
  delRollAct,
  refundSummary,

  newUserInvite,
  newUserList,
  resultStatistics,
  newUserStatistics,
  newUserState,
  videoChatStatistics,
  massTextingIM,
  getMassTextingPage,
  newGroupInvite,
  groupAuditList,
  groupAuditStatistics,
  goldList,
  getTemplateAct,
  getAddTemplateAct,
  getEditTemplateAct,
  getGiftAct,
  getUpdateGiftAct,
  delTemplateAct,
  getCopyAct,
  getTaskAct,
  getAddTaskAct,
  getEditTaskAct,
  delTaskAct,
  getCopyTaskAct,
  getAwardAct,
  getAddAwardAct,
  getEditAwardAct,
  delAwardAct,
  uploadTeamUser,
  getTeamUser,
  putTeamUser,
  downloadRank,
  getUserRecharge,
  getListAct,
  getMendAct,
  getTeamList,
  getDeleteTeam,
  amendIDFun,
  getSelectList,
  addTeam,
  editTeam,
  pushMsgTeam,
  getInviteList,
  addBound,
  delBound,
  getPlatform,
  getInviteParty,
  getPartyAudit,
  getInvitePartyCenter,
  getPartyAuditCenter,
  getChargeAward,
  getCer,
  getPartyAuditCer,
  getOperation,
  getModal,
  getIphone,
  bangDingIphone,
  getArea,
  getVersions,
  getEditVersions,
  genToken,
  getCac,
  getDayUser,
  getNameplate,
  putNameplate,
  postNameplate,
  getNameplateUser,
  postNameplateRemove,
  postNameplateUser,
  userMemo,
  getBlackList,
  delBlackList,
  postBlackList,
  getWhiteList,
  postWhiteList,
  delWhiteList
};



// WEBPACK FOOTER //
// ./src/js/http.js